import apiV2 from "api-v2";

import type { QuoteResourceType } from "./procurer-quotes-api";
import { postAnalyzeMultipart, type QuoteImportApi } from "./quote-import-shared";
import { createTemplateQuoteImportApi } from "./quote-template-import-api";

/** RFx quote import — `rfx/{rfxId}/quotes/ai-import/*`. */
export const createRfxQuoteImportApi = (rfxId: number): QuoteImportApi => ({
	analyze: (file) =>
		postAnalyzeMultipart(`rfx/${rfxId}/quotes/ai-import/analyze`, file),
	apply: async (tables) => {
		await apiV2.post(`rfx/${rfxId}/quotes/ai-import/apply`, { tables });
	},
});

/**
 * Select the correct import api by `resourceType`. This is the endpoint-selection
 * fix (task 006 AC2): the modal no longer hardcodes the RFx path, so it targets
 * the right endpoint/ID space whether mounted from the RFx QuoteTab or the
 * `CreateRFxTemplate.js` template wizard (task 007).
 *
 * NOTE: "quote-settings" (task 010) is not resolved here — the settings surface
 * has no `rfxId`/`rfx_template_id` to key off, so `AiSpreadsheetImport` is always
 * mounted with an explicit `importApi={createQuoteSettingsImportApi()}` override
 * (see `quote-templates-import-api.ts`) rather than a resourceId-keyed resolver
 * branch. `resourceType="quote-settings"` is still passed for documentation/typing
 * purposes but is never used to resolve the api when `importApi` is supplied.
 */
export const resolveQuoteImportApi = (
	resourceType: QuoteResourceType,
	resourceId: number
): QuoteImportApi => {
	if (resourceType === "rfx-template") {
		return createTemplateQuoteImportApi(resourceId);
	}
	return createRfxQuoteImportApi(resourceId);
};
